import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss']
})
export class TextAreaComponent {
  @Input() control!: FormControl;
  @Input() submitted: boolean = false;
  @Input() placeholder: string = "";
  @Input() errorMessage: string = "";
}
